export const placeHolder = {
    page: 'templateV2',
    // subtitle: '海量优质模板，支持营销图批量生产',
    image: 'https://feed-image.baidu.com/0/pic/363303151_-860739105_1428428070.png'
};

export const btbIndustry = [
    '机械设备',
    '化工及能源',
    '农林牧渔',
    '电子电工'
];

export const normalIndustry = [
    '全部行业',
    '房产家居',
    '旅游服务',
    '交通出行',
    '整形美容',
    '教育培训',
    '金融服务',
    '商品交易',
    '医疗服务',
    '生活服务',
    '文娱传媒',
    '商务服务',
    '游戏',
    '软件',
    '网络服务',
    '通信',
    '直营电商',
    '食品饮料',
    '保健品/药品'
];

export const openIndustryByHot = [
    '全部行业',
    '教育培训',
    '文娱传媒',
    '金融服务',
    '生活服务',
    '房产家居',
    '整形美容',
    '商务服务',
    '旅游服务',
    '商品交易',
    '游戏',
    '软件',
    '交通出行',
    '网络服务',
    '机械设备',
    '医疗服务',
    '农林牧渔',
    '通信',
    '化工及能源',
    '电子电工',
    '直营电商',
    '食品饮料',
    '保健品/药品'
];

export const industryOptionsByNum = [
    {
        value: '',
        label: '全部行业',
        industry: ''
    },
    {
        value: '5',
        label: '教育培训',
        industry: 'EDUCATION'
    },
    {
        value: '19',
        label: '文娱传媒',
        industry: 'CULTURE'
    },
    {
        value: '10',
        label: '金融服务',
        industry: 'FINANCE'
    },
    {
        value: '8',
        label: '生活服务',
        industry: 'LIFE'
    },
    {
        value: '11',
        label: '房产家居',
        industry: 'ESTATE'
    },
    {
        value: '4',
        label: '整形美容',
        industry: 'BEAUTY'
    },
    {
        value: '7',
        label: '商务服务',
        industry: 'COMMERCIAL'
    },
    {
        value: '17',
        label: '旅游服务',
        industry: 'TRAVEL'
    },
    {
        value: '9',
        label: '商品交易',
        industry: 'SALE'
    },
    {
        value: '16',
        label: '游戏',
        industry: 'GAME'
    },
    {
        value: '15',
        label: '软件',
        industry: 'SOFTWARE'
    },
    {
        value: '13',
        label: '交通出行',
        industry: 'VEHICLE_PLT'
    },
    {
        value: '30',
        label: '网络服务',
        industry: 'NETWORK'
    },
    {
        value: '14',
        label: '机械设备',
        industry: 'MACHINE'
    },
    {
        value: '3',
        label: '医疗服务',
        industry: 'MEDICAL'
    },
    {
        value: '31',
        label: '农林牧渔',
        industry: 'FORESTRY'
    },
    {
        value: '29',
        label: '通信',
        industry: 'COMMUNICATION'
    },
    {
        value: '20',
        label: '化工及能源',
        industry: 'ENERGY'
    },
    {
        value: '28',
        label: '电子电工',
        industry: 'ELECTRONIC'
    },
    {
        value: '34',
        label: '直营电商',
        industry: 'DTC'
    },
    {
        value: '25',
        label: '食品饮料',
        industry: 'FOOD'
    },
    {
        value: '22',
        label: '保健品/药品',
        industry: 'DRUG'
    }
];

export const industryOptionsByName = [
    {
        value: '',
        label: '全部行业',
        num: ''
    },
    {
        value: 'EDUCATION',
        label: '教育培训',
        num: '5'
    },
    {
        value: 'CULTURE',
        label: '文娱传媒',
        num: '19'
    },
    {
        value: 'FINANCE',
        label: '金融服务',
        num: '10'
    },
    {
        value: 'LIFE',
        label: '生活服务',
        num: '8'
    },
    {
        value: 'ESTATE',
        label: '房产家居',
        num: '11'
    },
    {
        value: 'BEAUTY',
        label: '整形美容',
        num: '4'
    },
    {
        value: 'COMMERCIAL',
        label: '商务服务',
        num: '7'
    },
    {
        value: 'TRAVEL',
        label: '旅游服务',
        num: '17'
    },
    {
        value: 'SALE',
        label: '商品交易',
        num: '9'
    },
    {
        value: 'GAME',
        label: '游戏',
        num: '16'
    },
    {
        value: 'SOFTWARE',
        label: '软件',
        num: '15'
    },
    {
        value: 'VEHICLE_PLT',
        label: '交通出行',
        num: '13'
    },
    {
        value: 'NETWORK',
        label: '网络服务',
        num: '30'
    },
    {
        value: 'MACHINE',
        label: '机械设备',
        num: '14'
    },
    {
        value: 'MEDICAL',
        label: '医疗服务',
        num: '3'
    },
    {
        value: 'FORESTRY',
        label: '农林牧渔',
        num: '31'
    },
    {
        value: 'COMMUNICATION',
        label: '通信',
        num: '29'
    },
    {
        value: 'ENERGY',
        label: '化工及能源',
        num: '20'
    },
    {
        value: 'ELECTRONIC',
        label: '电子电工',
        num: '28'
    },
    {
        value: 'DTC',
        label: '直营电商',
        num: '34'
    },
    {
        value: 'FOOD',
        label: '食品饮料',
        num: '25'
    },
    {
        value: 'DRUG',
        label: '保健品/药品',
        num: '22'
    }
];

export const btbIndustryTradeId = [
    2005,
    2029,
    2027,
    2024
];

export const btbIndustryNumList = [
    14,
    20,
    31,
    28
];

export const industryTradeIdMap = {
    2001: '3',
    2002: '4',
    2005: '14',
    2006: '7',
    2007: '8',
    2008: '19',
    2010: '13',
    2015: '10',
    2017: '15',
    2018: '16',
    2019: '5',
    2020: '17',
    2022: '9',
    2023: '11',
    2024: '28',
    2025: '29',
    2026: '30',
    2027: '31',
    2029: '20'
};

export const openIndustry = [
    ...normalIndustry,
    ...btbIndustry
];

export const designSizeOptions =  [
    {
        value: '1:1',
        label: '1:1',
        children: [
            {
                value: '600*600',
                label: '600*600'
            }
        ]
    }, {
        value: '3:2',
        label: '3:2',
        children: [
            {
                value: '960*640',
                label: '960*640'
            }, {
                value: '1200*800',
                label: '1200*800'
            }, {
                value: '900*600',
                label: '900*600'
            }
        ]
    }, {
        value: '16:9',
        label: '16:9',
        children: [
            {
                value: '1140*640',
                label: '1140*640'
            }, {
                value: '1280*720',
                label: '1280*720'
            }, {
                value: '1600*900',
                label: '1600*900'
            }, {
                value: '1920*1080',
                label: '1920*1080'
            }, {
                value: '960*540',
                label: '960*540'
            }
        ]
    }, {
        value: '3:4',
        label: '3:4',
        children: [
            {
                value: '750*1000',
                label: '750*1000'
            }
        ]
    }, {
        value: '3:1',
        label: '3:1',
        children: [
            {
                value: '1200*400',
                label: '1200*400'
            }
        ]
    }, {
        value: '9:16',
        label: '9:16',
        children: [
            {
                value: '1080*1920',
                label: '1080*1920'
            },
            {
                value: '640*1140',
                label: '640*1140'
            }
        ]
    }
];

export const intelSizeOptions = [
    {
        value: '1:1',
        label: '1:1',
        children: [
            {
                value: '600*600',
                label: '600*600'
            }
            // {
            //     value: '240*240',
            //     label: '240*240'
            // }, {
            //     value: '120*120',
            //     label: '120*120'
            // }, {
            //     value: '80*80',
            //     label: '80*80'
            // }, {
            //     value: '220*220',
            //     label: '220*220'
            // }, {
            //     value: '250*250',
            //     label: '250*250'
            // }, {
            //     value: '360*360',
            //     label: '360*360'
            // }, {
            //     value: '480*480',
            //     label: '480*480'
            // }, {
            //     value: '600*600',
            //     label: '600*600'
            // }, {
            //     value: '300*300',
            //     label: '300*300'
            // }
        ]
    }, {
        value: '2:1',
        label: '2:1',
        children: [
            {
                value: '800*400',
                label: '800*400'
            }, {
                value: '600*300',
                label: '600*300'
            }
        ]
    }, {
        value: '3:2',
        label: '3:2',
        children: [
            {
                value: '960*640',
                label: '960*640'
            },
            {
                value: '1200*800',
                label: '1200*800'
            }, {
                value: '900*600',
                label: '900*600'
            }
            // {
            //     value: '370*245',
            //     label: '370*245'
            // }, {
            //     value: '960*640',
            //     label: '960*640'
            // }, {
            //     value: '378*252',
            //     label: '378*252'
            // }, {
            //     value: '1200*800',
            //     label: '1200*800'
            // }, {
            //     value: '900*600',
            //     label: '900*600'
            // }, {
            //     value: '300*200',
            //     label: '300*200'
            // }
        ]
    }, {
        value: '2:3',
        label: '2:3',
        children: [
            {
                value: '1080*1620',
                label: '1080*1620'
            }, {
                value: '1242*1863',
                label: '1242*1863'
            }
        ]
    }, {
        value: '3:1',
        label: '3:1',
        children: [
            {
                value: '1200*400',
                label: '1200*400'
            }, {
                value: '1152*384',
                label: '1152*384'
            }, {
                value: '900*300',
                label: '900*300'
            }
        ]
    }, {
        value: '4:3',
        label: '4:3',
        children: [
            {
                value: '800*600',
                label: '800*600'
            }
            // , {
            //     value: '120*90',
            //     label: '120*90'
            // }
        ]
    }, {
        value: '9:16',
        label: '9:16',
        children: [
            {
                value: '1080*1920',
                label: '1080*1920'
            }, {
                value: '1242*2208',
                label: '1242*2208'
            }, {
                value: '720*1280',
                label: '720*1280'
            }
        ]
    }, {
        value: '16:9',
        label: '16:9',
        children: [
            {
                value: '1140*640',
                label: '1140*640'
            }, {
                value: '1280*720',
                label: '1280*720'
            }, {
                value: '1600*900',
                label: '1600*900'
            }, {
                value: '1920*1080',
                label: '1920*1080'
            }, {
                value: '960*540',
                label: '960*540'
            }
        ]
    }
];

export const promptMatchList = [
    {
        key: '客厅',
        value: '宽敞的客厅，大窗户，沙发，茶几，现代，极简，深米色，灰色，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '楼盘',
        value: '高层独立建筑，黄昏，整洁，规则，灯光，现代，极简，银色和浅色靛蓝，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '卧室',
        value: '宽敞的卧室，床，木地板，现代，极简，米色，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '餐厅',
        value: '宽敞的餐厅，大窗户，餐桌，餐椅，大理石地板，现代，极简，米色，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '别墅',
        value: '别墅客厅，双高空间，大落地窗，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '车间',
        value: '流水线，工厂，绿色地板，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '毛坯',
        value: '一个正在装修的空屋，建筑材料，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '办公室',
        value: '宽敞的办公区域，几张办公桌，办公椅，电脑，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '衣帽间',
        value: '宽敞的衣帽间，衣柜，镜子，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '厨房',
        value: '宽敞的厨房，岛台，大理石地板，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '书房',
        value: '宽敞的现代书房，大窗户，书桌，椅子，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '洗手间',
        value: '宽敞浴室，马桶，淋浴，大理石地板，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '城市',
        value: '城市天际线夜景，高楼，河，灯光，霓虹，明亮，色彩丰富，蓝紫色天空，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '山川',
        value: '阿尔卑斯山风景，绿色草地，清澈的湖水，水面反射出山脉，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '沙滩',
        value: '斯里兰卡美丽海滩，白色沙滩，棕榈树，海湾海滨，清澈的蓝色海水，海岸两侧绿色植物为背景，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '草原',
        value: '云南山谷，草原风景，河流，草地。天空在阳光下泛着蓝色的光芒，田园诗般的场景，大自然，壮丽，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '海景',
        value: '俯瞰菲律宾岛屿，海湾海滨，背景是绿松石色的海水和岩石，绿色植物，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '酒店',
        value: '高端酒店客房，宽敞的房间，床，窗帘，大落地窗，现代，广角，明亮，真实风格，照片级，丰富细节，高质量，HD'
    },
    {
        key: '古镇',
        value: '徽派建筑，古镇，河，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '机场',
        value: '航空，白色涂装，在柔和的云层上方飞行，蓝天背景，航空摄影师，清澈的蓝天，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '老虎',
        value: '动物园，老虎，草地，岩石，动物摄影，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '熊猫',
        value: '动物园，大熊猫吃竹子，草地，动物摄影，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '海洋馆',
        value: '水族馆，鲨鱼和鱼在游动，人们在外面观看的剪影，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '教室',
        value: '教室，黑板，课桌，椅子，广角，明亮，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '操场',
        value: '学校，绿色草坪，教学楼，中景，自然光照，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '前台',
        value: '美容院，大厅，前台，沙发，大理石地面，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '手术室',
        value: '美容院，手术台，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '美容院',
        value: '美容院，白色医美床，大理石地面，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '牙科',
        value: '现代化的牙科办公室，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    },
    {
        key: '走廊',
        value: '美容院走廊，大理石地板，现代，极简，明亮，广角，真实风格，照片级，专业的色彩分级，高对比度，丰富细节，高质量，HD'
    }
];

export const domainMap = {
    bg: 1,
    mainPart: 2
};